import { render, staticRenderFns } from "./tariffeRecord.vue?vue&type=template&id=3b3a67cc&scoped=true"
import script from "./tariffeRecord.vue?vue&type=script&lang=js"
export * from "./tariffeRecord.vue?vue&type=script&lang=js"
import style0 from "./tariffeRecord.vue?vue&type=style&index=0&id=3b3a67cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3a67cc",
  null
  
)

export default component.exports